<div id="layoutSidenav">
  <div id="layoutSidenav_nav">
    <app-sidebar-nav></app-sidebar-nav>
  </div>
  <div id="layoutSidenav_content" class="bg-pink">
    <div class="container-fluid">
      <div class="d-flex bd_adminhead">
        <!-- <button class="navbar-toggler bd_toggle order-1 order-lg-0" id="sidebarToggle">
                    <span class="navbar-toggler-icon"></span>
                </button> -->
        <a class="bd_adminlogo mr-auto" routerLink="/dashboard">
          <img src="assets/img/admin_logo.png" />
        </a>
        <div class="full-screenbtn d-flex align-items-center">
          <!-- <button type="button"   class="bd_btn green_btn add_btn btn mr-2 full-screenbtn" (click)="fullscreen()">
                  Full Screen
                </button>&nbsp; -->
          <button
            type="button"
            class="bd_btn black_btn add_btn btn exit-fullscreenbtn mx-auto"
            (click)="exitfullscreen()"
          >
            Exit Full Screen
          </button>
        </div>
        <div class="ml-auto">
          <div class="dropdown">
            <a
              href="javascript:void(0)"
              class="bd_user dropdown-toggle"
              id="dropdownleftmenu"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              (click)="toogleTag()"
            >
              <ng-container *ngIf="user$ | async as userDetails">
                <div class="bd_usericon">
                  <img
                    [src]="userDetails?.company_info?.logo || defaultAvatar"
                    [class.bd_userlogo]="userDetails?.company_info?.logo"
                  />
                </div>
                <div class="bd_usertext">
                  <h2>
                    {{ userDetails.name }}
                    <span>{{ userDetails.company_info?.company_name }}</span>
                  </h2>
                </div>
              </ng-container>
            </a>
            <div
              class="dropdown-menu bd_dropdown"
              aria-labelledby="dropdownleftmenu"
              *ngIf="showMe"
            >
              <a
                class="nav-link"
                href="javascript:;"
                (click)="authService.userLogout()"
                ><i class="fa fa-sign-out" aria-hidden="true"></i>Logout</a
              >
              <a class="nav-link" routerLink="/dashboard/profile/my-account"
                ><i class="fa fa-user" aria-hidden="true"></i>My Account</a
              >
              <a class="nav-link" routerLink="/dashboard/profile/password-reset"
                ><i class="fa fa-key" aria-hidden="true"></i>Password Change</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
